export default "__VITE_ASSET__6b7ab5f1__"